import API from 'src/services/api';

import { IFilesSpec } from './types';
import { AxiosResponse } from 'axios';

const fileSpecApi = {
  async fetchFileSpec(): Promise<AxiosResponse<IFilesSpec>> {
    return await API.get(`/filespec`);
  },
};

export default fileSpecApi;
